import { WORKSPACE_STORAGE_TYPE } from '@bangle.io/constants';

/** User-facing label for a workspace storage source (sidebar subtitle, etc.). */
export function getWorkspaceStorageSourceLabel(type: string): string {
  switch (type) {
    case WORKSPACE_STORAGE_TYPE.Supabase:
      return t.app.components.appSidebar.storageSources.supabase;
    case WORKSPACE_STORAGE_TYPE.Browser:
      return t.app.components.appSidebar.storageSources.browser;
    case WORKSPACE_STORAGE_TYPE.NativeFS:
      return t.app.components.appSidebar.storageSources.nativefs;
    case WORKSPACE_STORAGE_TYPE.Memory:
      return t.app.components.appSidebar.storageSources.memory;
    case WORKSPACE_STORAGE_TYPE.Help:
      return t.app.components.appSidebar.storageSources.helpfs;
    case WORKSPACE_STORAGE_TYPE.PrivateFS:
      return t.app.components.appSidebar.storageSources.privatefs;
    case WORKSPACE_STORAGE_TYPE.Github:
      return t.app.components.appSidebar.storageSources.github;
    default:
      return type.length === 0
        ? type
        : `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
  }
}
